import throttle from 'lodash/throttle';
import afterPaint from '../../../js/__utils/afterPaint';
const navigationSubMenus = document.querySelectorAll(
	'.block-navigation-submenu'
);
const navigationBackButtons = document.querySelectorAll(
	'.block-navigation-submenu__back-button'
);
const navigationMenu = document.querySelector('.block-navigation__menu');

const clickNavigationBackButton = (e) => {
	const currentNavigationBackButton = e.currentTarget;
	const navigationLink = currentNavigationBackButton.closest(
		'.block-navigation-link'
	);

	if (!navigationLink) {
		return;
	}

	navigationMenu.classList.remove('nav-link-opened');
	navigationLink.classList.remove('active');
};

const setMenuOffset = () => {
	if (0 === navigationSubMenus.length) {
		return;
	}

	// --submenuOffset feeds a translateX that getBoundingClientRect() reports, so reset all before measuring any.
	navigationSubMenus.forEach((navigationSubMenu) => {
		navigationSubMenu.classList.add('container');
		navigationSubMenu.style.setProperty('--submenuOffset', `0rem`);
	});

	const viewportWidth = window.innerWidth;
	const measurements = [];

	navigationSubMenus.forEach((navigationSubMenu) => {
		const navigationSubMenuRect = navigationSubMenu.getBoundingClientRect();

		if (0 === navigationSubMenuRect.width || !navigationSubMenuRect.x) {
			return;
		}

		const navigationBlock = navigationSubMenu.closest(
			'.block-navigation__container'
		);
		let navigationBlockWidth = viewportWidth;

		if (navigationBlock) {
			const navigationBlockStyles =
				window.getComputedStyle(navigationBlock);
			navigationBlockWidth =
				navigationBlock.offsetWidth -
				parseFloat(navigationBlockStyles['padding-left']) -
				parseFloat(navigationBlockStyles['padding-right']);
		}

		measurements.push({
			navigationSubMenu,
			navigationSubMenuRect,
			navigationBlockWidth,
		});
	});

	measurements.forEach(
		({
			navigationSubMenu,
			navigationSubMenuRect,
			navigationBlockWidth,
		}) => {
			const navigationSubMenuLeft = navigationSubMenuRect.x;
			const navigationSubMenuRight =
				navigationSubMenuRect.x + navigationSubMenuRect.width;
			const containerLeft = (viewportWidth - navigationBlockWidth) / 2;
			const containerRight = containerLeft + navigationBlockWidth;
			let offset = 0;

			if (navigationSubMenuLeft < containerLeft) {
				offset = containerLeft - navigationSubMenuLeft;
			} else if (navigationSubMenuRight > containerRight) {
				offset = containerRight - navigationSubMenuRight;
			}

			navigationSubMenu.style.setProperty(
				'--submenuOffset',
				`${offset / 16}rem`
			);
		}
	);
};

if (navigationBackButtons.length > 0) {
	navigationBackButtons.forEach((navigationBackButton) => {
		navigationBackButton.addEventListener(
			'click',
			clickNavigationBackButton
		);
	});
}

// Opening a submenu recalculates these, so keep the initial pass off the critical path.
afterPaint(setMenuOffset);

window.addEventListener('navigation-submenu-opened', setMenuOffset);
window.addEventListener('resize', throttle(setMenuOffset, 100));
window.addEventListener('load', setMenuOffset);
